import { render, staticRenderFns } from "./ProviderApprovalResultRow.vue?vue&type=template&id=453c5522&scoped=true"
import script from "./ProviderApprovalResultRow.vue?vue&type=script&lang=js"
export * from "./ProviderApprovalResultRow.vue?vue&type=script&lang=js"
import style0 from "./ProviderApprovalResultRow.vue?vue&type=style&index=0&id=453c5522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c5522",
  null
  
)

export default component.exports